import { render, staticRenderFns } from "./NoteComp.vue?vue&type=template&id=60d6bf82&scoped=true"
import script from "./NoteComp.vue?vue&type=script&lang=js"
export * from "./NoteComp.vue?vue&type=script&lang=js"
import style0 from "./NoteComp.vue?vue&type=style&index=0&id=60d6bf82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d6bf82",
  null
  
)

export default component.exports